import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/config/footerLinks";

type FooterSectionType = "feature" | "guides" | "check-up";

type FooterLinkItem = {
  name: string;
  link: string;
  target?: "_blank" | "_self";
};

export type FooterLinkSection = {
  title: string;
  type: FooterSectionType;
  list: FooterLinkItem[];
};

export function getFooterLinkSections(locale: string): FooterLinkSection[] {
  const I18n = I18nUtil.createScoped(Translations);
  const localePrefix = locale === "en" ? "" : `/${locale}`;
  const href = (path: string) => `${localePrefix}${path}`;

  return [
    {
      title: I18n.t("Feature", { locale }),
      type: "feature",
      list: [
        {
          name: I18n.t("Financial Fitness", { locale }),
          link: href("/financial-fitness"),
        },
        {
          name: I18n.t("Pricing", { locale }),
          link: href("/pricing"),
        },
      ],
    },
    {
      title: I18n.t("Guides", { locale }),
      type: "guides",
      list: [
        {
          name: I18n.t("What is a Money Person", { locale }),
          link: href("/article/what-is-a-money-person"),
        },
        {
          name: I18n.t("What is Financial Fitness", { locale }),
          link: href("/article/what-is-financial-fitness"),
        },
        {
          name: I18n.t("RSU vested money tool", { locale }),
          link: href("/article/rsu-vested-money-tool-surfaces-first"),
        },
        {
          name: I18n.t("Are you behind on retirement savings", { locale }),
          link: href("/article/are-you-behind-on-retirement-savings"),
        },
      ],
    },
    {
      title: I18n.t("Check-up", { locale }),
      type: "check-up",
      list: [
        {
          name: I18n.t("Financial Fitness Check", { locale }),
          link: href("/check-up/ed-financial-fitness-check"),
        },
        {
          name: I18n.t("Money Personality", { locale }),
          link: href("/check-up/ed-money-personality"),
        },
        {
          name: I18n.t("Will You Be a Billionaire", { locale }),
          link: href("/check-up/will-you-be-a-billionaire"),
        },
      ],
    },
  ];
}
